import { useCallback, useEffect, useRef } from 'react';

const useDebounceCallback = <Targs, Treturn>(
  callback: (...args: Targs[]) => Treturn,
  delay: number
): ((...args: Targs[]) => Treturn | void) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return useCallback(
    (...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => callbackRef.current(...args), delay);
    },
    [delay]
  );
};

export default useDebounceCallback;
